import { z } from 'zod';

export const FederationKind = z.enum(['data-exchange', 'federated-learning', 'capacity-exchange']);

export const FedAgreement = z.object({
  id: z.string(),
  tenantAId: z.string(),
  tenantBId: z.string(),
  kind: FederationKind,
  scope: z.object({
    dataCategoriesAllowed: z.array(z.string()),
    learningAggregateOnly: z.boolean().default(true),
    capacityKinds: z.array(z.string()).default([]),
  }),
  consent: z.object({
    tenantAConsent: z.object({ at: z.string(), userId: z.string() }),
    tenantBConsent: z.object({ at: z.string(), userId: z.string() }),
  }),
  effectiveAt: z.string(),
  revokedAt: z.string().nullable().default(null),
  revokedByTenantId: z.string().nullable().default(null),
  correlationId: z.string(),
});

export const FederationExchange = z.object({
  id: z.string(),
  agreementId: z.string(),
  fromTenantId: z.string(),
  toTenantId: z.string(),
  kind: FederationKind,
  payloadRef: z.string(),
  exchangedAt: z.string(),
  correlationId: z.string(),
});
